import { render, staticRenderFns } from "./uspBlock.vue?vue&type=template&id=cc610844&"
import script from "./uspBlock.vue?vue&type=script&lang=js&"
export * from "./uspBlock.vue?vue&type=script&lang=js&"
import style0 from "./uspBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports